import * as React from "react";
function SvgCross(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={5}
      ref={svgRef}
      {...props}
    >
      <path d="M2 2l28 28M30 2L2 30" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCross);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
